// React
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
// MUI
import { Grid, Box, Button, Toolbar, styled, Typography } from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
// Constants
import EntityConstants from "../../../configs/EntityConstants";
import MessageContants from "../../../configs/MessageContants";
// Service
import { get, post, put } from "../../../services/FetchHelper";
import SpinService from "../../../services/SpinService";
// Utils
import {
    InitialZoneState,
    ZoneSchema,
    ZoneFormFields,
} from "./Configuration.utils";
// Styles
import { StyledDrawerForm } from "../../../configs/GoStyles";
//Third party
import { Form, Formik } from "formik";
import toast from "react-hot-toast";
import GoForm from "../../../components/Inputs/GoForm";

import PermissionConstants from "../../../configs/PermissionConstants";
import usePermissions from "../../../hooks/usePermissions";
const Zone = ({ id, onClose }) => {
    const permissions = usePermissions();
    const spinService = SpinService();
    const [zone, setZone] = useState(InitialZoneState);
    const [formFields, setFormFields] = useState(ZoneFormFields);

    const attachOptions = (name, options) => {
        setFormFields(prevFormFields =>
            prevFormFields.map(field =>
                field.name === name && (field.type === "select" || field.type === "multiselect")
                    ? { ...field, options: options }
                    : field
            )
        );
    };

    const handleChangeSchools = async () => {
        spinService.on();
        const response = await get(EntityConstants.SCHOOLSBYCOMPANIES);
        const data = await response.json();
        attachOptions("school_id", data);
        spinService.off();
    };

    const handleChangeAreas = async (school_id) => {
        spinService.on();
        const response = await get(EntityConstants.AREAS, `type=zone&school_id=${school_id}&zone_id=${id}`);
        const data = await response.json();
        attachOptions("areas", data);
        spinService.off();
    };

    const getZone = async (id) => {
        spinService.on();
        const response = await get(EntityConstants.ZONES + `/${id}`);
        const data = await response.json();
        setZone(data);
        handleChangeAreas(data.school_id);
        spinService.off();
    };

    const handleSubmit = async (values) => {
        spinService.on();
        const isNewZone = values.id === undefined;
        const url = isNewZone ? EntityConstants.ZONES : EntityConstants.ZONES + `/${values.id}`;
        const method = isNewZone ? post : put;
        const response = await method(url, { zone: values });
        if ([200, 201].indexOf(response.status) > -1) {
            toast.success(isNewZone ? MessageContants.ZONE_CREATED : MessageContants.ZONE_UPDATED);
            onClose();
        }
        spinService.off();
    };

    const handleCustomChange = (e) => {
        if (e.target.name === "school_id") {
            handleChangeAreas(e.target.value)
        }
    }

    useEffect(() => {
        handleChangeSchools();
        if (id !== undefined) {
            getZone(Number(id));
        }
    }, [id]);

    return (
        <div>
            <Formik
                enableReinitialize
                initialValues={zone}
                validationSchema={ZoneSchema}
                onSubmit={(values) => handleSubmit(values)}
            >
                {({
                    values,
                    touched,
                    errors,
                    dirty,
                    isSubmitting,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                }) => (
                    <Form noValidate onSubmit={handleSubmit}>
                        <StyledDrawerForm>
                            <Grid
                                container
                                maxWidth="sm"
                                rowSpacing={1}
                                columnSpacing={{ xs: 1, sm: 2, md: 2 }}
                            >
                                {formFields.map((formField, index) => {
                                    return (
                                        <Grid key={index} item xs={12} sm={12} md={6} lg={6}>
                                            <GoForm
                                                config={formField}
                                                values={values}
                                                touched={touched}
                                                errors={errors}
                                                handleChange={(e) => { handleChange(e); handleCustomChange(e) }}
                                            />
                                        </Grid>
                                    );
                                })}
                            </Grid>
                            <Box sx={{ p: 2, textAlign: "right" }}>
                                <Button
                                    variant="contained"
                                    color="error"
                                    startIcon={<Iconify icon="eva:close-circle-outline" />}
                                    onClick={() => onClose()}
                                >
                                    Close
                                </Button>
                                &nbsp;&nbsp;
                                {((values.id === undefined && permissions.has(PermissionConstants.ZONE_CREATE)) || (values.id !== undefined && permissions.has(PermissionConstants.ZONE_UPDATE))) &&
                                    <Button
                                        variant="contained"
                                        startIcon={<Iconify icon="eva:save-fill" />}
                                        type="submit"
                                    >
                                        {values.id === undefined ? 'Save' : 'Update'}
                                    </Button>}
                            </Box>
                        </StyledDrawerForm>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

Zone.propTypes = {
    id: PropTypes.number,
    onClose: PropTypes.any,
};

export default Zone;
